import type { PayloadFormatter } from './types';

export const formatDefaultPayload: PayloadFormatter = (args) => {
  const formatLabel = (key: string): string =>
    key
      .split(/[-_]/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

  const formatValue = (value: unknown): string => {
    if (typeof value === 'string') return value;
    if (typeof value === 'object' && value !== null) {
      return JSON.stringify(value, null, 2);
    }
    return String(value);
  };

  const entries = Object.entries(args).filter(([, value]) => value != null);
  const lines = entries.map(([key, value]) => {
    const label = formatLabel(key);
    const formattedValue = formatValue(value);

    if (
      typeof value === 'object' ||
      (typeof formattedValue === 'string' && formattedValue.length > 100)
    ) {
      return `**${label}:**\n\`\`\`json\n${formattedValue}\n\`\`\``;
    }
    return `**${label}:** ${formattedValue}`;
  });

  return lines.length > 0 ? lines.join('\n\n') : null;
};
